// Complete bilingual content for all business data

export const CONTENT = {
  fr: {
    // Documents obligatoires
    doc_facture: 'Facture commerciale définitive',
    doc_facture_details: 'Désignation précise, prix unitaire/total, incoterm, pays d\'origine, signature et cachet.',
    doc_packing: 'Liste de colisage (Packing List)',
    doc_packing_details: 'Détail par colis, poids brut/net, cohérente avec la facture.',
    doc_bl: 'Connaissement (Bill of Lading) ou LTA',
    doc_bl_details: 'Original endossé par la banque requis.',
    doc_eur1: 'Certificat EUR.1',
    doc_eur1_details: 'Économie sur les DD. Délivré par la Chambre de Commerce + visa douane. Validité 10 mois.',
    doc_cert_arabe: 'Certificat d\'origine GZALE',
    doc_cert_arabe_details: 'Exonération DD. Délivré par la Chambre de Commerce du pays exportateur.',
    doc_cert_standard: 'Certificat d\'origine standard',
    doc_cert_standard_details: 'Obligatoire pour les douanes algériennes. Délivré par la Chambre de Commerce.',
    doc_ppi: 'PPI validé (statut "Traité" sur import.mcepe.gov.dz)',
    doc_ppi_details: 'Obligatoire depuis 09/07/2025. Sans PPI validé = domiciliation impossible.',
    doc_rc: 'Extrait du Registre du Commerce',
    doc_rc_details: 'Doit être à jour et correspondre au code activité déclaré.',
    doc_domiciliation: 'Domiciliation bancaire',
    doc_domiciliation_details: 'Ouvrir dès réception du connaissement.',
    doc_tdb_services: 'Attestation TDB + Quittance DGI',
    doc_tdb_services_details: 'TDB services = 4% du montant. À payer à la recette des impôts avant domiciliation.',
    doc_tdb_negoce: 'Attestation TDB + Quittance DGI',
    doc_tdb_negoce_details: 'TDB biens revente = 0.3% (min 20 000 DZD). À payer avant domiciliation.',
    doc_auto_cosm: 'Autorisation préalable cosmétiques',
    doc_auto_cosm_details: 'Décret n°97-37. Délai ~60 jours. Ministère du Commerce.',
    doc_fiche_tech: 'Fiche technique du produit (FR ou AR)',
    doc_fiche_tech_details: 'Dénomination, caractéristiques techniques, normes, pays de fabrication.',

    // FAP
    fap_cc: 'Contrôle de Conformité',
    fap_cc_org: 'Inspection aux frontières — Ministère du Commerce',
    fap_cc_desc: 'Vérification de la conformité du produit aux normes algériennes',
    fap_cc_delai: '2 à 5 jours ouvrables',
    fap_hiet: 'Homologation Équipements Terminaux — ARPCE',
    fap_hiet_org: 'ARPCE',
    fap_hiet_desc: 'Homologation obligatoire avant importation (Loi n°18-04)',
    fap_hiet_delai: '30 à 60 jours',
    fap_vph: 'Visa Phytosanitaire',
    fap_vph_org: 'INPV',
    fap_vph_desc: 'Contrôle phytosanitaire à l\'entrée sur le territoire',
    fap_vph_delai: '3 à 7 jours',
    fap_isv: 'Inspection Sanitaire Vétérinaire',
    fap_isv_org: 'Ministère de l\'Agriculture — Services vétérinaires',
    fap_isv_desc: 'Contrôle sanitaire vétérinaire obligatoire',
    fap_isv_delai: '2 à 5 jours',
    fap_vti: 'Visa Technique à l\'Importation',
    fap_vti_org: 'ANPP — Ministère de la Santé',
    fap_vti_desc: 'Autorisation préalable obligatoire pour médicaments',
    fap_vti_delai: '30 à 90 jours',
    fap_vim: 'Visa Instruments de Mesure',
    fap_vim_org: 'ALGERAC',
    fap_vim_desc: 'Vérification métrologique des instruments de mesure',
    fap_ati: 'Autorisation Technique à l\'Importation — Végétaux',
    fap_ati_org: 'INPV',
    fap_ati_desc: 'Autorisation pour pesticides et produits phytosanitaires',

    // Disclaimers
    disclaimer_general: 'Ces informations sont fournies à titre indicatif uniquement. Elles sont basées sur la réglementation en vigueur à la date indiquée. La réglementation algérienne du commerce extérieur évolue fréquemment par circulaires et notes ministérielles. Vérifiez toujours les dernières dispositions avant d\'expédier votre commande.',
    disclaimer_sh: 'Le code SH suggéré est basé sur la description fournie. Le classement tarifaire définitif est de la compétence exclusive des Douanes algériennes. En cas de doute, consultez votre transitaire agréé ou adressez une demande de renseignement à la Direction Générale des Douanes.',
    disclaimer_calcul: 'Les montants calculés sont des estimations basées sur les taux en vigueur. Le montant définitif est liquidé par les services douaniers lors du dédouanement et peut différer selon la valeur déclarée et le taux de change officiel du jour.',
    disclaimer_ue: 'Note 2025-2026 : Des tensions existent entre l\'Algérie et l\'UE concernant l\'application de l\'accord d\'association. Vérifiez auprès de votre transitaire que le taux préférentiel EUR.1 est bien accepté pour votre produit.',
    disclaimer_docs: 'Cette checklist est basée sur les textes réglementaires identifiés à la date indiquée. Des documents supplémentaires peuvent être exigés selon l\'inspection douanière, la wilaya concernée, ou des circulaires récentes.',

    // Etiquetage
    etiq_arabe_title: 'Langue arabe obligatoire',
    etiq_arabe_desc: 'Toutes les mentions doivent être en arabe (à titre principal). Autres langues autorisées à titre accessoire.',
    etiq_arabe_loi: 'Loi n°09-03 du 25/02/2009 — art. 3',
    etiq_gtin_title: 'Code-barres GTIN / GS1',
    etiq_gtin_desc: 'Code-barres GS1 (GTIN) obligatoire sur tout produit préemballé. Enregistrement GS1 Algeria + dépôt CACI.',
    etiq_gtin_loi: 'Arrêté du 16/02/2021',
    etiq_gtin_exception: 'Matières premières en vrac, équipements industriels non préemballés.',
    etiq_alim_title: 'Mentions produits alimentaires',
    etiq_alim_loi: 'Décret exécutif n°05-484 + modifications',
    etiq_cosm_title: 'Mentions produits cosmétiques',
    etiq_cosm_loi: 'Décret exécutif n°97-37 modifié et complété',
    etiq_non_alim_title: 'Mentions produits non alimentaires',

    etiq_alim_items: ['Dénomination de vente','Liste des ingrédients (ordre décroissant)','Allergènes en gras','Quantité nette','Date limite de consommation (DLC) ou durabilité minimale (DDM)','Conditions de conservation','Pays d\'origine','Identification du fabricant/importateur','Lot de fabrication'],
    etiq_cosm_items: ['Composition (INCI)','Précautions particulières d\'utilisation','Numéro de lot','Date de durabilité minimale','Fonction du produit si non évidente'],
    etiq_non_alim_items: ['Dénomination du produit','Pays d\'origine ou de provenance','Identification du fabricant ou importateur','Mode d\'emploi si nécessaire','Précautions d\'utilisation'],

    // DAPS
    daps_warning: 'Ce produit est soumis au DAPS — Droit Additionnel Provisoire de Sauvegarde. Cette taxe protectionniste s\'applique même aux produits UE bénéficiant de 0% DD.',
  },

  ar: {
    // Documents obligatoires
    doc_facture: 'الفاتورة التجارية النهائية',
    doc_facture_details: 'تعيين دقيق، السعر الوحدوي/الإجمالي، شرط التسليم، بلد المنشأ، التوقيع والختم.',
    doc_packing: 'قائمة التعبئة (Packing List)',
    doc_packing_details: 'تفصيل لكل طرد، الوزن الصافي/الإجمالي، متوافقة مع الفاتورة.',
    doc_bl: 'سند الشحن (Bill of Lading) أو بوليصة الشحن الجوي',
    doc_bl_details: 'النسخة الأصلية المظهرة من البنك مطلوبة.',
    doc_eur1: 'شهادة EUR.1',
    doc_eur1_details: 'توفير في الرسوم الجمركية. تصدر من غرفة التجارة + تأشيرة الجمارك. صالحة 10 أشهر.',
    doc_cert_arabe: 'شهادة المنشأ العربية (GZALE)',
    doc_cert_arabe_details: 'إعفاء من الرسوم الجمركية. تصدر من غرفة تجارة البلد المصدر.',
    doc_cert_standard: 'شهادة المنشأ العادية',
    doc_cert_standard_details: 'إلزامية للجمارك الجزائرية. تصدر من غرفة التجارة.',
    doc_ppi: 'البرنامج التقديري المصادق عليه (حالة "معالج" على import.mcepe.gov.dz)',
    doc_ppi_details: 'إلزامي منذ 09/07/2025. بدون برنامج تقديري مصادق = استحالة التوطين البنكي.',
    doc_rc: 'مستخرج السجل التجاري',
    doc_rc_details: 'يجب أن يكون ساري المفعول ومطابقاً لرمز النشاط المصرح به.',
    doc_domiciliation: 'التوطين البنكي',
    doc_domiciliation_details: 'يُفتح فور استلام سند الشحن.',
    doc_tdb_services: 'شهادة رسم التوطين البنكي + وصل الضرائب',
    doc_tdb_services_details: 'رسم التوطين للخدمات = 4% من المبلغ. يُدفع لدى قباضة الضرائب قبل التوطين.',
    doc_tdb_negoce: 'شهادة رسم التوطين البنكي + وصل الضرائب',
    doc_tdb_negoce_details: 'رسم التوطين لإعادة البيع = 0.3% (الحد الأدنى 20,000 د.ج). يُدفع قبل التوطين.',
    doc_auto_cosm: 'الترخيص المسبق لمستحضرات التجميل',
    doc_auto_cosm_details: 'المرسوم رقم 97-37. المدة ~60 يوماً. وزارة التجارة.',
    doc_fiche_tech: 'البطاقة التقنية للمنتج (بالعربية أو الفرنسية)',
    doc_fiche_tech_details: 'التسمية، الخصائص التقنية، المعايير، بلد الصنع.',

    // FAP
    fap_cc: 'مراقبة المطابقة',
    fap_cc_org: 'التفتيش على الحدود — وزارة التجارة',
    fap_cc_desc: 'التحقق من مطابقة المنتج للمعايير الجزائرية',
    fap_cc_delai: '2 إلى 5 أيام عمل',
    fap_hiet: 'المصادقة على التجهيزات الطرفية — ARPCE',
    fap_hiet_org: 'سلطة ضبط البريد والاتصالات الإلكترونية',
    fap_hiet_desc: 'المصادقة إلزامية قبل الاستيراد (القانون رقم 18-04)',
    fap_hiet_delai: '30 إلى 60 يوماً',
    fap_vph: 'التأشيرة الصحية النباتية',
    fap_vph_org: 'المعهد الوطني لحماية النباتات',
    fap_vph_desc: 'المراقبة الصحية النباتية عند الدخول إلى الإقليم',
    fap_vph_delai: '3 إلى 7 أيام',
    fap_isv: 'التفتيش الصحي البيطري',
    fap_isv_org: 'وزارة الفلاحة — المصالح البيطرية',
    fap_isv_desc: 'المراقبة الصحية البيطرية الإلزامية',
    fap_isv_delai: '2 إلى 5 أيام',
    fap_vti: 'التأشيرة التقنية للاستيراد',
    fap_vti_org: 'الوكالة الوطنية للمنتجات الصيدلانية — وزارة الصحة',
    fap_vti_desc: 'ترخيص مسبق إلزامي للأدوية',
    fap_vti_delai: '30 إلى 90 يوماً',
    fap_vim: 'تأشيرة أدوات القياس',
    fap_vim_org: 'الهيئة الجزائرية للاعتماد',
    fap_vim_desc: 'التحقق المترولوجي لأدوات القياس',
    fap_ati: 'الترخيص التقني للاستيراد — النباتات',
    fap_ati_org: 'المعهد الوطني لحماية النباتات',
    fap_ati_desc: 'ترخيص للمبيدات والمنتجات الصحية النباتية',

    // Disclaimers
    disclaimer_general: 'هذه المعلومات مقدمة على سبيل الاستدلال فقط. وهي مبنية على التنظيم الساري المفعول في التاريخ المشار إليه. ينظم التجارة الخارجية الجزائرية يتطور باستمرار عبر المناشير والمذكرات الوزارية. تحقق دائماً من آخر الأحكام قبل إرسال طلبيتك.',
    disclaimer_sh: 'رمز النظام المنسق المقترح مبني على الوصف المقدم. التصنيف الجمركي النهائي من اختصاص الجمارك الجزائرية حصرياً. في حالة الشك، استشر وكيلك الجمركي المعتمد.',
    disclaimer_calcul: 'المبالغ المحسوبة هي تقديرات مبنية على المعدلات السارية. المبلغ النهائي يُصفى من طرف مصالح الجمارك عند التخليص الجمركي.',
    disclaimer_ue: 'ملاحظة 2025-2026: توجد توترات بين الجزائر والاتحاد الأوروبي بشأن تطبيق اتفاق الشراكة. تحقق من وكيلك الجمركي أن المعدل التفضيلي EUR.1 مقبول لمنتجك.',
    disclaimer_docs: 'هذه القائمة مبنية على النصوص التنظيمية المحددة في التاريخ المشار إليه. قد تُطلب وثائق إضافية حسب التفتيش الجمركي أو الولاية المعنية.',

    // Etiquetage
    etiq_arabe_title: 'اللغة العربية إلزامية',
    etiq_arabe_desc: 'جميع البيانات يجب أن تكون بالعربية (بصفة رئيسية). اللغات الأخرى مسموح بها بصفة ثانوية.',
    etiq_arabe_loi: 'القانون رقم 09-03 المؤرخ في 25/02/2009 — المادة 3',
    etiq_gtin_title: 'الرمز الشريطي GTIN / GS1',
    etiq_gtin_desc: 'الرمز الشريطي GS1 (GTIN) إلزامي على كل منتج معبأ مسبقاً. التسجيل في GS1 الجزائر + الإيداع لدى الغرفة الجزائرية للتجارة.',
    etiq_gtin_loi: 'القرار المؤرخ في 16/02/2021',
    etiq_gtin_exception: 'المواد الأولية السائبة، التجهيزات الصناعية غير المعبأة مسبقاً.',
    etiq_alim_title: 'بيانات المنتجات الغذائية',
    etiq_alim_loi: 'المرسوم التنفيذي رقم 05-484 + التعديلات',
    etiq_cosm_title: 'بيانات مستحضرات التجميل',
    etiq_cosm_loi: 'المرسوم التنفيذي رقم 97-37 المعدل والمتمم',
    etiq_non_alim_title: 'بيانات المنتجات غير الغذائية',

    etiq_alim_items: ['تسمية البيع','قائمة المكونات (بالترتيب التنازلي)','مسببات الحساسية بخط عريض','الكمية الصافية','تاريخ انتهاء الصلاحية أو الحد الأدنى للمتانة','شروط الحفظ','بلد المنشأ','تعريف المصنع/المستورد','رقم الحصة'],
    etiq_cosm_items: ['التركيبة (INCI)','احتياطات الاستعمال الخاصة','رقم الحصة','تاريخ الحد الأدنى للمتانة','وظيفة المنتج إذا لم تكن واضحة'],
    etiq_non_alim_items: ['تسمية المنتج','بلد المنشأ أو المصدر','تعريف المصنع أو المستورد','طريقة الاستعمال إذا لزم الأمر','احتياطات الاستعمال'],

    // DAPS
    daps_warning: 'هذا المنتج خاضع للرسم الإضافي المؤقت للحماية (DAPS). هذا الرسم الحمائي يُطبق حتى على منتجات الاتحاد الأوروبي المستفيدة من 0% رسوم جمركية.',
  },
};

// Helper to get FAP content by code
const FAP_KEYS = {
  'C.C': 'cc', 'H.I.E.T': 'hiet', 'V.P.H': 'vph', 'I.S.V': 'isv',
  'D.S.V': 'isv', 'V.T.I': 'vti', 'V.I.M': 'vim', 'A.T.I': 'ati', 'I.S': 'cc',
};

export function getFapContent(code, lang) {
  const k = FAP_KEYS[code] || 'cc';
  const c = CONTENT[lang] || CONTENT.fr;
  return {
    nom: c[`fap_${k}`],
    organisme: c[`fap_${k}_org`],
    description: c[`fap_${k}_desc`],
    delai: c[`fap_${k}_delai`] || '',
  };
}
